import ActivateAccount from "../pages/ActivateAccount";
import RequestActivateToken from "../pages/RequestActivateToken";
import DataRequestForm from "../pages/DataRequestForm";
import Login from "../pages/Login";
import Logout from "../pages/Logout";
import ResetPassword from "../pages/ResetPassword";
import FrameworksPage from "../pages/FrameworksPage";
import RegisterUserAccount from "../pages/RegisterUserAccount";
import ForgotPassword from "../pages/ForgotPassword";
import ApplicantDashboard from "../pages/ApplicantDashboard";
import NotFound from "../framework/pages/404";
import Home from "../pages/Home";
import ObservershipApplicationForm from "../pages/ObservershipApplicationForm";
import webRootContext from "./webrootcontext/WebRootContext";
import UploadVisa from "../pages/UploadVisa";
import UploadHealthInsurance from "../pages/UploadHealthInsurance";
import ExpectationsForm from "../pages/ExpectationsForm";
import UpdateApplicationDocuments from "../pages/UpdateApplicationDocuments";

// window.location.href Need to be based context root.
// Archetype will replace  path.


const navigation = [
  {
    to: webRootContext + "/",
    text: "Dashboard",
    component: ApplicantDashboard,
    displayOrder: 12,
    showInMenu: false,
    allowAccess: ["RESTRICTED"],
    needExact: true
  },
  {
    to: webRootContext + "/Home",
    text: "Home",
    component: Home,
    displayOrder: 12,
    showInMenu: false,
    allowAccess: ["ALL"],
    needExact: false
  },
  {
    to: webRootContext + "/FrameworksPage",
    text: "Components Page",
    component: FrameworksPage,
    displayOrder: 8,
    showInMenu: false,
    allowAccess: ["RESTRICTED"],
    needExact: false
  },
  {
    to: webRootContext + "/CreateAccount",
    text: "Create Account",
    component: RegisterUserAccount,
    displayOrder: 10,
    showInMenu: false,
    allowAccess: ["ALL"],
    needExact: false
  },
  {
    to: webRootContext + "/ActivateAccount",
    text: "Activate Account",
    component: ActivateAccount,
    displayOrder: 4,
    showInMenu: false,
    allowAccess: ["ALL"],
    needExact: false
  },
  {
    to: webRootContext + "/RequestActivateToken",
    text: "Request Activation Token",
    component: RequestActivateToken,
    displayOrder: 5,
    showInMenu: false,
    allowAccess: ["ALL"],
    needExact: false
  },
  {
    to: webRootContext + "/Login",
    text: "Login",
    component: Login,
    displayOrder: 6,
    showInMenu: false,
    allowAccess: ["ALL"],
    needExact: false
  },
  {
    to: webRootContext + "/ObservershipApplicationForm",
    text: "Observership Application Form",
    component: ObservershipApplicationForm,
    displayOrder: 6,
    showInMenu: false,
    allowAccess: ["RESTRICTED"],
    needExact: false
  },
  {
    to: webRootContext + "/ForgotPassword",
    text: "Forgot Password",
    component: ForgotPassword,
    displayOrder: 7,
    showInMenu: false,
    allowAccess: ["ALL"],
    needExact: false
  },
  {
    to: webRootContext + "/ResetPassword",
    text: "Reset Password",
    component: ResetPassword,
    displayOrder: 9,
    showInMenu: false,
    allowAccess: ["ALL"],
    needExact: false
  },
  {
    to: webRootContext + "/UploadVisa",
    text: "Proof of Visa or Passport",
    component: UploadVisa,
    displayOrder: 10,
    showInMenu: false,
    allowAccess: ["RESTRICTED"],
    needExact: false
  },
  {
    to: webRootContext + "/ApplicantDashboard",
    text: "Dashboard",
    component: ApplicantDashboard,
    displayOrder: 12,
    showInMenu: false,
    allowAccess: ["RESTRICTED"],
    needExact: true
  },
  {
    to: webRootContext + "/DataRequestForm",
    text: "Data Request Form",
    component: DataRequestForm,
    displayOrder: 13,
    showInMenu: false,
    allowAccess: ["RESTRICTED"],
    needExact: false
  },
  {
    to: webRootContext + "/UploadHealthInsurance",
    text: "Proof of Health Insurance",
    component: UploadHealthInsurance,
    displayOrder: 10,
    showInMenu: false,
    allowAccess: ["RESTRICTED"],
    needExact: false
  },
  {
    to: webRootContext + "/UpdateApplicationDocuments",
    text:"UpdateApplicationDocuments",
    component: UpdateApplicationDocuments,
    displayOrder : 10,
    showInMenu : false,
    allowAccess : ["RESTRICTED"],
    needExact : false
  },
  {
    to: webRootContext + "/ExpectationsForm",
    text: "Expectations Agreement",
    component: ExpectationsForm,
    displayOrder: 14,
    showInMenu: false,
    allowAccess: ["RESTRICTED"],
    needExact: false
  },
  {
    to: webRootContext + "/Logout",
    text: "Logout",
    component: Logout,
    displayOrder: 10,
    showInMenu: false,
    allowAccess: ["ALL"],
    needExact: false
  },
  {
    to: "*",
    text: "404",
    component: NotFound,
    displayOrder: 11,
    showInMenu: false,
    allowAccess: ["ALL"],
    needExact: false
  },


  //The $webRootContext entry below seems to break everything after it.
  {
    to: webRootContext + "/",
    text: "",
    component: ApplicantDashboard,
    allowAccess: ["RESTRICTED"],
    displayOrder: 12,
  }
];

export default navigation;